export const WEATHER = [
  {
    id: 200,
    en: 'Thunderstorm with light rain',
    ru: 'Гроза с небольшим дождём',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 201,
    en: 'Thunderstorm with rain',
    ru: 'Гроза с дождем',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 202,
    en: 'Thunderstorm with heavy rain',
    ru: 'Гроза с сильным дождем',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 210,
    en: 'Light thunderstorm',
    ru: 'Легкая гроза',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 211,
    en: 'Thunderstorm',
    ru: 'Гроза',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 212,
    en: 'Heavy thunderstorm',
    ru: 'Сильная гроза',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 221,
    en: 'Ragged thunderstorm',
    ru: 'Рваная гроза',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 230,
    en: 'Thunderstorm with light drizzle',
    ru: 'Гроза с мелким дождем',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 231,
    en: 'Thunderstorm with drizzle',
    ru: 'Гроза с моросящим дождем',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 232,
    en: 'Thunderstorm with heavy drizzle',
    ru: 'Гроза с сильным моросящим дождем',
    icon_id: 11,
    ais_icon_name: '130g',
  },
  {
    id: 300,
    en: 'Light intensity drizzle',
    ru: 'Мелкая изморось',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 301,
    en: 'Drizzle',
    ru: 'Изморось',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 302,
    en: 'Heavy intensity drizzle',
    ru: 'Изморось',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 310,
    en: 'Light intensity drizzle rain',
    ru: 'Моросящий дождь',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 311,
    en: 'Drizzle rain',
    ru: 'Моросящий дождь',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 312,
    en: 'Heavy intensity drizzle rain',
    ru: 'Сильный моросящий дождь',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 313,
    en: 'Shower rain and drizzle',
    ru: 'Сильный моросящий дождь',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 314,
    en: 'Heavy shower rain and drizzle',
    ru: 'Сильный моросящий дождь',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 321,
    en: 'Shower drizzle',
    ru: 'Сильный моросящий дождь',
    icon_id: 9,
    ais_icon_name: '130e',
  },
  {
    id: 500,
    en: 'Light rain',
    ru: 'Небольшой дождь',
    icon_id: 10,
    ais_icon_name: '130e',
  },
  {
    id: 501,
    en: 'Moderate rain',
    ru: 'Дождь',
    icon_id: 10,
    ais_icon_name: '130e',
  },
  {
    id: 502,
    en: 'Heavy intensity rain',
    ru: 'Сильный интенсивный дождь',
    icon_id: 10,
    ais_icon_name: '130e',
  },
  {
    id: 503,
    en: 'Very heavy rain',
    ru: 'Очень сильный дождь',
    icon_id: 10,
    ais_icon_name: '130e',
  },
  {
    id: 504,
    en: 'Extreme rain',
    ru: 'Сильный дождь',
    icon_id: 10,
    ais_icon_name: '130e',
  },
  {
    id: 511,
    en: 'Freezing rain',
    ru: 'Ледяной дождь',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 520,
    en: 'Light intensity shower rain',
    ru: 'Ливневый дождь',
    icon_id: 9,
    ais_icon_name: '130f',
  },
  {
    id: 521,
    en: 'Shower rain',
    ru: 'Ливневый дождь',
    icon_id: 9,
    ais_icon_name: '130f',
  },
  {
    id: 522,
    en: 'Heavy intensity shower rain',
    ru: 'Сильный ливневый дождь',
    icon_id: 9,
    ais_icon_name: '130f',
  },
  {
    id: 531,
    en: 'Ragged shower rain',
    ru: 'Сильный ливневый дождь',
    icon_id: 9,
    ais_icon_name: '130f',
  },
  {
    id: 600,
    en: 'Light snow',
    ru: 'Легкий снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 601,
    en: 'Snow',
    ru: 'Снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 602,
    en: 'Heavy snow',
    ru: 'Сильный снегопад',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 611,
    en: 'Sleet',
    ru: 'Мокрый снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 612,
    en: 'Fight shower sleet',
    ru: 'Небольшой мокрый снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 613,
    en: 'Shower sleet',
    ru: 'Ливневый мокрый снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 615,
    en: 'Light rain and snow',
    ru: 'Небольшой дождь и снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 616,
    en: 'Rain and snow',
    ru: 'Дождь со снегом',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 620,
    en: 'Light shower snow',
    ru: 'Ливневый снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 621,
    en: 'Shower snow',
    ru: 'Ливневый снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 622,
    en: 'Heavy shower snow',
    ru: 'Сильный ливневый снег',
    icon_id: 13,
    ais_icon_name: '130h',
  },
  {
    id: 701,
    en: 'Mist',
    ru: 'Туман',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 711,
    en: 'Smoke',
    ru: 'Дым',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 721,
    en: 'Haze',
    ru: 'Туман',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 731,
    en: 'Sand/dust whirls',
    ru: 'Песчаные/пылевые вихри',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 741,
    en: 'Fog',
    ru: 'Туман',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 751,
    en: 'Sand',
    ru: 'Песок',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 761,
    en: 'Dust',
    ru: 'пыль',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 762,
    en: 'Volcanic ash',
    ru: 'Вулканический пепел',
    icon_id: 50,
    ais_icon_name: '130i',
  },
  {
    id: 771,
    en: 'Squalls',
    ru: 'Шквал',
    icon_id: 50,
    ais_icon_name: '130j',
  },
  {
    id: 781,
    en: 'Tornado',
    ru: 'Торнадо',
    icon_id: 50,
    ais_icon_name: '130k',
  },
  {
    id: 800,
    en: 'Clear sky',
    ru: 'Ясно',
    icon_id: 1,
    ais_icon_name: '130a',
  },
  {
    id: 801,
    en: 'Few clouds',
    ru: 'Небольшая облачность',
    icon_id: 2,
    ais_icon_name: '130b',
  },
  {
    id: 802,
    en: 'Scattered clouds',
    ru: 'Переменная облачность',
    icon_id: 3,
    ais_icon_name: '130c',
  },
  {
    id: 803,
    en: 'Broken clouds',
    ru: 'Облачно с прояснениями',
    icon_id: 4,
    ais_icon_name: '130d',
  },
  {
    id: 804,
    en: 'Overcast clouds',
    ru: 'Пасмурно',
    icon_id: 4,
    ais_icon_name: '130d',
  },
];
